export type Player = {
  id: string
  name: number
}

export type CardSet = {
  index: number
  values: string[]
}

export enum AppStatus {
  showIntroduction,
  enterName,
  enterGameId,
  startGame,
  gameStarted,
}

export enum GameStatus {
  gameStarted,
  startNextRound,
  waitForApplications,
  showApplications,
  waitForPicks,
  showResults,
  readyForScoring,
  redrawCards,
}

export enum PlayerGameStatus {
  gameStarted,
  waitForConnections,
  selectAJobAsBoss,
  waitForOffer,
  createApplication,
  createInitiativeApplication,
  selectSalaryExpectations,
  waitForApplications,
  showApplications,
  pickApplication,
  waitForPicks,
  showPicks,
  showResults,
  waitForNewCards,
}

const salaryExpectationClass: Array<string> = [
  'silver',
  'bronze',
  'silver',
  'gold',
]

export { salaryExpectationClass }

export interface Message {
  short: string
  long: string
}

export type Mapper<T> = {
  [key: string]: T
}

export type Connection = {
  job: string
  boss: string
  applicant: string
  ready: boolean
}
